/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 5835:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9062);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3324);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5671);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(136);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2963);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1120);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7112);
/* harmony import */ var _utils_body_lock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1709);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var StudiosuiteStarter = /*#__PURE__*/function (_HTMLElement) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(StudiosuiteStarter, _HTMLElement);

  var _super = _createSuper(StudiosuiteStarter);

  function StudiosuiteStarter() {
    var _document$querySelect;

    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, StudiosuiteStarter);

    _this = _super.call(this);

    var gridItems = _this.querySelectorAll('.starting-grid__item');

    var sectionId = _this.getAttribute('data-section-id');

    var productTemplateId = (_document$querySelect = document.querySelector('.main-product__inner--configurator')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.id;
    var isOverlay = _this.getAttribute('data-is-overlay') === 'true' ? true : false;
    var parent = document.querySelector('.studiosuite-starter');
    var loadURL = new URL(window.location.href);
    var mainProductInner = document.querySelector('.main-product__inner');

    var inspirationButton = _this.querySelector('.starting-grid__item--inspiration');

    var startFreshbutton = _this.querySelector('.starting-grid__item--start-fresh');

    var hiddenStartingGridItems = _this.querySelectorAll('.starting-grid__item--hidden');

    var closeButton = _this.querySelector('.close-button');

    var outerElement = document.querySelector('.studiosuite-starter');

    var starterDescription = _this.querySelector('.starter-description');

    var starterSubtitle = _this.querySelector('.starter-subtitle');

    var starterTitle = _this.querySelector('.starter-title');

    var starterBackButton = _this.querySelector('.starter-button');

    var shareButton = document.querySelector('.share-button');

    var inpirationText = _this.querySelector('.title-holder__inspiration-text');

    if (loadURL.searchParams.size >= 1) {
      parent.classList.add('studiosuite-starter--hidden');
    }
    /**
     * @param {HTMLDom} dom 
     * @param {sectionsArray} sectionsArray
     * renders product filters
     */


    var renderSections = function renderSections(dom, sectionsArray) {
      sectionsArray.forEach(function (section) {
        var source = dom.querySelector(section);
        var destination = document.querySelector(section);
        destination.innerHTML = source.innerHTML;
        setTimeout(function(){ 
              var radio = destination.querySelector('.configurator-variant.layer--1');
              if (radio) {
                destination.querySelectorAll('.configurator-variant').forEach(function (selector) {
                    selector.classList.add('hidden');
                  });          
                destination.querySelector('.configurator-variant.layer--1').classList.remove("hidden");
              }
          },500);
      });
    };

    var handleConfigurationBackInteraction = function handleConfigurationBackInteraction() {
      inspirationButton.classList.add('starting-grid__item--inspiration');
      inspirationButton.classList.remove('starting-grid__item--hidden');
      startFreshbutton.classList.add('starting-grid__item--start-fresh');
      startFreshbutton.classList.remove('starting-grid__item--hidden');
      inpirationText.classList.add('title-holder__inspiration-text--hidden');
      starterDescription.classList.remove('starter-description--hidden');
      starterSubtitle.classList.remove('starter-subtitle--hidden');
      starterTitle.classList.remove('starter-title--hidden');
      starterBackButton.classList.add('starter-button--hidden');
      hiddenStartingGridItems.forEach(function (item) {
        item.classList.add('starting-grid__item--hidden');
      });
    };

    var handleInspirationReveal = function handleInspirationReveal() {
      // if (startFreshbutton.classList.contains('starting-grid__item--start-fresh')) {
      //   startFreshbutton.classList.add('starting-grid__item--hide-start-fresh')
      // }
      inspirationButton.classList.remove('starting-grid__item--inspiration');
      inspirationButton.classList.add('starting-grid__item--hidden');
      startFreshbutton.classList.remove('starting-grid__item--start-fresh');
      startFreshbutton.classList.add('starting-grid__item--hidden');
      inpirationText.classList.remove('title-holder__inspiration-text--hidden');
      starterDescription.classList.add('starter-description--hidden');
      starterSubtitle.classList.add('starter-subtitle--hidden');
      starterTitle.classList.add('starter-title--hidden');
      starterBackButton.classList.remove('starter-button--hidden');
      hiddenStartingGridItems.forEach(function (item) {
        item.classList.remove('starting-grid__item--hidden');
      });
    };

    var handleKlaviyo = function handleKlaviyo() {
      var _document$querySelect2;

      // let _learnq = _learnq || [];
      (_document$querySelect2 = document.querySelector('.js-a2c')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.addEventListener('click', function () {
        var selectedItems = JSON.parse(sessionStorage.getItem('configuratorConfig'));
        var filteredItems = selectedItems.filter(function (selectedItem) {
          return selectedItem !== null;
        });
        var filteredItemsWithResource = filteredItems.map(function (filteredItem) {
          return _objectSpread({
            addedBy: 'studioSUITE',
            urlParams: window.location.href
          }, filteredItem);
        });

        _learnq.push(['track', 'Added to Cart', filteredItemsWithResource]);

        console.log(_learnq);
      });
    };

    var handleConfiguratorSections = function handleConfiguratorSections(url, e) {
      window.history.pushState('studiosuite starting point', '', url.href);
      url.searchParams.set('sections', "".concat(productTemplateId));
      sessionStorage.removeItem('configuratorConfig');
      axios__WEBPACK_IMPORTED_MODULE_4___default().get(url.href).then(function (response) {
        Object.entries(response.data).forEach(function (_ref) {
          var _ref2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          var dom = new DOMParser().parseFromString(value, 'text/html');
          var sectionsArray = ['.main-product__inner'];
          renderSections(dom, sectionsArray);
          setTimeout(function () {
            parent.classList.add('studiosuite-starter--hidden');
            mainProductInner.classList.add('main-product__inner--configurator-active');
            e.target.classList.remove('loading');
            _utils_body_lock__WEBPACK_IMPORTED_MODULE_3__/* ["default"].unlock */ .Z.unlock();
            handleKlaviyo();
             setTimeout(function(){ 
                var radio = document.querySelector('.configurator-variant.layer--1');
                if (radio) {
                  document.querySelectorAll('.configurator-variant').forEach(function (selector) {
                      selector.classList.add('hidden');
                    });          
                  document.querySelector('.configurator-variant.layer--1').classList.remove("hidden");
                }
            },500);
          }, 500);
        });
      });
    };

    var openGridItem = function openGridItem(e) {
      if (isOverlay) {
        e.target.classList.add('loading');
        var url = new URL(e.target.value === '/' ? window.location.href : "".concat(window.location.origin).concat(e.target.value));

        if (e.target.value === '/') {
          var keys = (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(url.searchParams.keys());

          keys.forEach(function (key) {
            url.searchParams.delete(key);
          });
        }

        if (e.target.value === '/show-inspiration') {
          handleInspirationReveal();
        } else {
          handleConfiguratorSections(url, e);
        }
      } else {
        window.location.href = e.target.value;
        parent.classList.add('studiosuite-starter--hidden');
      }
    };

    gridItems.forEach(function (gridItem) {
      gridItem.addEventListener('click', function (e) {
        openGridItem(e);
      });
    });

    var handleVisibilityState = function handleVisibilityState() {
      var url = new URL(window.location.href);

      if (url.searchParams.size < 1) {
        _utils_body_lock__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lock */ .Z.lock();
        parent.classList.remove('studiosuite-starter--hidden');
      } else {
        mainProductInner.classList.add('main-product__inner--configurator-active');
      }
    };

    handleVisibilityState();
    closeButton.addEventListener('click', function () {
      _utils_body_lock__WEBPACK_IMPORTED_MODULE_3__/* ["default"].unlock */ .Z.unlock();
      parent.classList.add('studiosuite-starter--hidden');
      mainProductInner.classList.add('main-product__inner--configurator-active');
    });
    outerElement.addEventListener('click', function (e) {
      if (e.target === outerElement) {
        _utils_body_lock__WEBPACK_IMPORTED_MODULE_3__/* ["default"].unlock */ .Z.unlock();
        parent.classList.add('studiosuite-starter--hidden');
        mainProductInner.classList.add('main-product__inner--configurator-active');
      }
    });
    starterBackButton.addEventListener('click', function () {
      handleConfigurationBackInteraction();
    });
    shareButton.addEventListener('click', function () {
      var copyText = shareButton.querySelector('#copy-text');
      var copyTextValue = copyText.innerHTML;
      navigator.clipboard.writeText(window.location.href);
      copyText.innerHTML = shareButton.getAttribute('data-copy-success');
      setTimeout(function () {
        copyText.innerHTML = copyTextValue;
      }, 2000);
    });
    window.addEventListener("popstate", function (event) {
      handleVisibilityState();
    });
    return _this;
  }

  return StudiosuiteStarter;
}( /*#__PURE__*/(0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(HTMLElement));

if (!customElements.get('studiosuite-starter')) {
  customElements.define('studiosuite-starter', StudiosuiteStarter);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	!function() {
/******/ 		__webpack_require__.j = 4654;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			4654: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkworkflow"] = self["webpackChunkworkflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [1216], function() { return __webpack_require__(5835); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;